(function (){
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .factory('Comparisons', Comparisons)
      .factory('ComparisonsMetric', ComparisonsMetricClass)
      .factory('ComparisonsType', ComparisonsTypeClass);

  function Comparisons(StandardReports, SectionConfig, ComparisonsMetric, Filters, DateUtil, $stateParams, ComparisonsType,
                       AreaLineChartConfig, $translate, standardReportNumberFilter){

    return {
      metrics : getMetrics,
      hierarchies: getHierarchies,
      dateRanges: getDateRanges,
      defaultDateRange: defaultDateRange,
      defaultHierarchy: defaultHierarchy,
      hierarchyCompareTooltipHeader: hierarchyCompareTooltipHeader,
      formatDateRange: formatDateRange,
      maxComparisonStartDate : maxComparisonStartDate,
      dateRangeCompareTooltipHeader: dateRangeCompareTooltipHeader,
      getSummaryValues: getSummaryValues,
      options: options,
      allMetricSummary: allMetricSummary
    };

    function getVisibleSeries(chartOptions) {
      return chartOptions && chartOptions.series &&
          _(chartOptions.series)
              .filter({visible: true})
              .map('name')
              .value();
    }

    function options(detailLevel, groupNames, headerFormatter, multipleXAxis) {
      var staticOptions = {
        detailLevel: detailLevel,
        custom: {
          multipleXAxis: multipleXAxis,
          groupNames: groupNames,
          headerFormatter: headerFormatter,
          xAxisFormatter: function () {
            return moment(this.value).format('DD MMM');
          }
        }
      };

      return function (section, chartOptions) {
        return _.extend(staticOptions, {
          section: section,
          valuePrefix: section.valuePrefix,
          visibleSeries: getVisibleSeries(chartOptions)
        })
      }
    }

    function getDateRanges(defaultParams) {
      return [
        ComparisonsType('Date Range 1', defaultDateRange('startDate', 'endDate', defaultParams),
            dateRangeSummaryLabel),
        ComparisonsType('Date Range 2', defaultDateRange('comparisonStartDate', 'comparisonEndDate', defaultParams),
            dateRangeSummaryLabel)
      ];
    }

    function getHierarchies(defaultParams) {
      return [
        ComparisonsType(hierarchyLabel, defaultHierarchy('department', 'category',
            'classification', 'addressable', defaultParams), hierarchyLabel),
        ComparisonsType(hierarchyLabel, defaultHierarchy('comparisonDepartment', 'comparisonCategory',
            'comparisonClassification', 'comparisonAddressable', defaultParams), hierarchyLabel)
      ];
    }

    function getMetrics(pageConfig) {

      function sectionForPage(pageConfig, sectionName) {
        return _.find(pageConfig.children, {name: sectionName});
      }

      return [
        ComparisonsMetric(sectionForPage(pageConfig, 'orders'), 'Orders', function (response) {
          return response;
        }),
        ComparisonsMetric(sectionForPage(pageConfig, 'sessions'), 'Sessions', function (response) {
          return response;
        }),
        ComparisonsMetric(sectionForPage(pageConfig, 'revenue'), 'Revenue', function (response) {
          var formattedRawData = StandardReports.transformIntoChartData('revenue')(response);
          return {
            dateMetrics: formattedRawData.dateMetrics,
            summary: response.summary
          };
        }),
        ComparisonsMetric(sectionForPage(pageConfig, 'mau'), 'Monthly Active Users (MAU)', function (response) {
          return response;
        }),
        ComparisonsMetric(sectionForPage(pageConfig, 'dau'), 'Daily Active Users (DAU)', function (response) {
          return response;
        }),
        ComparisonsMetric(sectionForPage(pageConfig, 'conversion'), 'Conversions', function (response) {
          return response;
        }),
        ComparisonsMetric(sectionForPage(pageConfig, 'spu'), 'Sessions per User (SPU)', function (response) {
          return response;
        }),
        ComparisonsMetric(sectionForPage(pageConfig, 'adoption'), 'True Fit Adoption', function (response) {
          return response;
        }),
        ComparisonsMetric(sectionForPage(pageConfig, 'newUsers'), 'New True Fit Users', function (response) {
          return response;
        })
      ];
    }

    function defaultDateRange(startDateAttr, endDateAttr, defaultParams) {
      return {
        startDate: DateUtil.shortMonthDate($stateParams[startDateAttr] || defaultParams.startDate),
        endDate: DateUtil.shortMonthDate($stateParams[endDateAttr] || defaultParams.endDate)
      };
    }

    function defaultHierarchy(departmentAttr, categoryAttr, classificationAttr, addressableAttr, defaultParams) {
      return {
        department: $stateParams[departmentAttr] || defaultParams.department,
        category: $stateParams[categoryAttr] || defaultParams.category,
        classification: $stateParams[classificationAttr] || defaultParams.classification,
        addressable: _.isUndefined($stateParams[addressableAttr]) ? $stateParams.addressable :
            $stateParams[addressableAttr]
      };
    }

    function hierarchyLabel() {
      var that = this;
      return _(['department', 'category', 'classification'])
          .map(function(hierarchy) {
            var value = that.value[hierarchy];
            return value === 'All TrueFit Addressable' ? 'All TF Addr' : value;
          })
          .join('/');
    }

    function hierarchyCompareTooltipHeader(groupNames) {
      var groupNamesHeader = _(groupNames).map(function (groupName) {
        return AreaLineChartConfig.tableHeader(groupName, 1);
      }).join('');
      return function (selectedPoint) {
        return AreaLineChartConfig.dateHeader(selectedPoint, 1).join('') + groupNamesHeader;
      }
    }

    function formatDateRange(dateRange) {
      return {
        startDate: DateUtil.formatToYearMonthDay(dateRange.startDate),
        endDate: DateUtil.formatToYearMonthDay(dateRange.endDate)
      }
    }

    function dateRangeSummaryLabel() {
      return _.map(this.value, function (value) {
        return DateUtil.fullMonthDate(value);
      }).join(' - ');
    }

    function maxComparisonStartDate(dateRange) {
      var filters = Filters.getFilter();
      var diff = moment(dateRange.endDate).diff(moment(dateRange.startDate), 'days');
      return DateUtil.shortMonthDate(moment(filters.maxAllowedDate).subtract(diff, 'days'));
    }

    function dateRangeCompareTooltipHeader(selectedPoint) {
      return '<th></th>' + AreaLineChartConfig.dateHeader(selectedPoint, 1).join('');
    }

    function getSummaryValues(summary, section, comparisonMetrics) {
      var comparisonMetricLabels = _.concat('',
          _.map(comparisonMetrics, function (metric) {
            return {value: metric.label()};
          }),
          { value:'Diff %' }
      );


      var valueColumns = _.flatMap(section.callout.values, function (callout) {
        return _.map(callout.values, function(calloutValue) {
           var userCohortValues = _.map(summary, function (values) {
             return StandardReports.findInSummary(values, callout.summaryKey, calloutValue.userCohort.value);
           });

           var firstRange = _.first(userCohortValues);
           var secondRange = _.last(userCohortValues);
           var diff = _.round(((secondRange - firstRange) / firstRange) * 100, 2);

           var calloutLabel = [ {color: calloutValue.color, value:$translate.instant(calloutValue.label)}];

           var valuePrefix = section.valuePrefix || '';
           var valueSuffix = section.valueSuffix || '';
           var formattedUserCohortValues = _.map(userCohortValues, function (value) {
             return  { color: calloutValue.color,
               value: valuePrefix + standardReportNumberFilter(_.round(value, 2)) + valueSuffix };
           });
           var formattedDiff = [ {color: calloutValue.color, value: standardReportNumberFilter(diff) + '%'} ];

           return _.concat(calloutLabel, formattedUserCohortValues, formattedDiff);
        });

      });

      return _(comparisonMetricLabels)
          .zip(_.unzip(valueColumns))
          .map(function (value) {
            return _.flatten(value);
          })
          .value();
    }

    function allMetricSummary(metrics, dataFn, comparisonMetrics) {
      return _.map(metrics, function (metric) {
        return dataFn(metric).then(function (data) {
          var comparisonValues = _(data)
              .map(function (rangeData, index) {
                var userCohortValues = _(metric.section.callout.values)
                    .flatMap(function (calloutValues) {
                      return _(calloutValues.values)
                          .map(function (calloutValue) {
                            return {
                              userCohort: calloutValue.userCohort.value,
                              value: StandardReports.findInSummary(rangeData.summary, calloutValues.summaryKey,
                                  calloutValue.userCohort.value),
                              color: calloutValue.color,
                              valuePrefix: metric.section.valuePrefix || '',
                              valueSuffix: metric.section.valueSuffix || ''
                            }
                          })
                          .value();
                    })
                    .value();

                return {
                  displayName: comparisonMetrics[index].label(),
                  userCohortValues: userCohortValues
                }
              })
              .value();

          var diff = {
            displayName: metric.displayName,
            userCohortValues: _(comparisonValues)
                .map('userCohortValues')
                .unzip()
                .map(function (userCohortValues) {
                  var firstRange = _.first(userCohortValues);
                  var secondRange = _.last(userCohortValues);
                  var diffValue = _.round(((secondRange.value - firstRange.value) / firstRange.value) * 100, 2);
                  return {
                    userCohort: firstRange.userCohort,
                    value: _.isFinite(diffValue) ? diffValue : '-.-'
                  };
                })
                .value()
          };

          return {
            diff: diff,
            comparisonValues: comparisonValues
          }
        });
      });
    }
  }

  function ComparisonsMetricClass() {

    function ComparisonsMetric(section, displayName, transformFunc) {
      if (!(this instanceof ComparisonsMetric))
        return new ComparisonsMetric(section, displayName, transformFunc);

      this.section = section;
      this.displayName = displayName;
      this.transformFunc = transformFunc;
    }

    return ComparisonsMetric;

  }

  function ComparisonsTypeClass() {

    function ComparisonsType(name, value, label) {
      if (!(this instanceof ComparisonsType))
        return new ComparisonsType(name, value, label);

      this.name = name;
      this.value = value;
      this.label = label;
    }

    return ComparisonsType;
  }

})();